import { render, staticRenderFns } from "./TopicoVideo.vue?vue&type=template&id=db380662&scoped=true&"
import script from "./TopicoVideo.vue?vue&type=script&lang=js&"
export * from "./TopicoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db380662",
  null
  
)

export default component.exports